import { Link } from 'react-router-dom';
import { EmptyState } from '../components/StateViews';

export function NotFoundView() {
  return (
    <div className="view">
      <EmptyState
        title="Page not found"
        glyph="—"
        action={
          <Link className="btn btn--primary" to="/">
            Back to events
          </Link>
        }
      >
        That route does not exist.
      </EmptyState>
    </div>
  );
}
